/**
 * Display-only estimate from the catalog selling price, never a transaction price.
 * Integer arithmetic rounds half-up to cents without binary floating-point drift.
 */
export function estimateGuestPrice(price: unknown): string | null {
  if (typeof price !== "string" && typeof price !== "number") return null;
  const text = String(price).trim();
  if (text.length > 64 || !/^\d+(?:\.\d+)?$/.test(text)) return null;
  const [whole, fraction = ""] = text.split(".");
  const amount = BigInt(whole + fraction);
  if (amount <= 0n) return null;
  const scale = 10n ** BigInt(fraction.length);
  // dollars * 1.03 * 100 = dollars * 103 cents
  const cents = (amount * 103n * 2n + scale) / (scale * 2n);
  if (cents <= 0n) return null;
  return `${cents / 100n}.${String(cents % 100n).padStart(2, "0")}`;
}

/** Case equivalents multiply the rounded displayed unit amount, not the baseline. */
export function estimatedCasePrice(estimate: string, units: number): string | null {
  if (!/^\d+\.\d{2}$/.test(estimate) || !Number.isSafeInteger(units) || units <= 0) return null;
  const cents = BigInt(estimate.replace(".", "")) * BigInt(units);
  return `${cents / 100n}.${String(cents % 100n).padStart(2, "0")}`;
}
